export default __webpack_public_path__ + "static/media/map-green-marker.422b8af3.svg";